import { Skeleton } from "@pg/design-system";

export const TableRowSkeleton = () => <Skeleton className="w-full rounded-[8px] h-5" />;